module.exports = __webpack_public_path__ + "static/media/icon_mental_idea.50a8345c.svg";